/*=========================================================================================
  File Name: modulevenue.js
  Description: venue Module
==========================================================================================*/


import state from './moduleVenueState.js'
import mutations from './moduleVenueMutations.js'
import actions from './moduleVenueActions.js'
import getters from './moduleVenueGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
